import { render, staticRenderFns } from "./Skill.vue?vue&type=template&id=6bb5fff2&"
import script from "./Skill.vue?vue&type=script&lang=js&"
export * from "./Skill.vue?vue&type=script&lang=js&"
import style0 from "./Skill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/1e153f50/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6bb5fff2', component.options)
    } else {
      api.reload('6bb5fff2', component.options)
    }
    module.hot.accept("./Skill.vue?vue&type=template&id=6bb5fff2&", function () {
      api.rerender('6bb5fff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Skill.vue"
export default component.exports